import { ILineItem } from '../../../lib/graphql';
import { BasketItemData } from '../types';
import { eventTicketLabel } from '../../../utils/eventTicketLabel';

/**
 * Business logic: Extract item data from basket line item
 * Handles different item types (course, exam, courseSession, eventTier)
 */
const extractItemData = (lineItem: ILineItem): BasketItemData => {
  if (lineItem.course) {
    const itemName = lineItem.course.courseGroup?.name
      ? `${lineItem.course.name}`
      : lineItem.course.name;
    return {
      id: lineItem.course.id,
      name: itemName,
      type: 'course',
      price: lineItem.price,
    };
  }

  if (lineItem.exam) {
    return {
      id: lineItem.exam.id,
      name: lineItem.exam.name,
      type: 'exam',
      price: lineItem.price,
    };
  }

  if (lineItem.courseSession) {
    return {
      id: lineItem.courseSession.id,
      name: `Taster - ${lineItem.courseSession.course.name}`,
      type: 'courseSession',
      price: lineItem.price,
    };
  }

  if (lineItem.eventTier) {
    return {
      id: lineItem.eventTier.id,
      name: eventTicketLabel(
        lineItem.eventTier.event.name,
        lineItem.eventTier,
        lineItem.eventPrice,
      ),
      type: 'EventTier',
      price: lineItem.price,
    };
  }

  // Fallback for unknown item types
  return {
    id: 0,
    name: 'Unknown item',
    type: 'unknown',
    price: lineItem.price,
  };
};

export default extractItemData;
